import { useRef, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

export default (action) => {
  const history = useHistory();
  const actionRef = useRef();
  // did update
  useEffect(() => {
    // It allows to keep most recent action for "will unmount" call
    actionRef.current = action;
  }, [action]);
  // will unmount
  useEffect(() => {
    return () => history.action === 'POP' && actionRef.current();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
